export const defaultCurrency = "EUR";
export const supportedCurrency = [
  { code: "USD", name: "USD ($) - United States Dollar" },
  { code: "EUR", name: "EUR (€) - Euro" },
  { code: "JPY", name: "JPY (¥) - Japanese Yen" },
  { code: "GBP", name: "GBP (£) - British Pound Sterling" },
  { code: "AUD", name: "AUD (A$) - Australian Dollar" },
  { code: "CAD", name: "CAD (C$) - Canadian Dollar" },
];
